<script>

  import jquery from 'jquery';
  import { onMount } from 'svelte';
  import textBalancer from './util/text-balancer';

  /**
   * Prop imports
   */
  // eslint-disable-next-line
  export let data;

  // Local variables
  let height = window.innerHeight;
  let width = window.innerWidth;

  let videoHorizontalOffset = 0;
  let videoVerticalOffset = 0;
  let videoWidthAdjust = 100;

  const videoWidth = 1920;
  const videoHeight = 1080;

  const calculateVideoOffset = () => {
    videoHorizontalOffset = 0;
    videoVerticalOffset = 0;

    if (width / height < videoWidth / videoHeight) {
      videoHorizontalOffset = - ((videoWidth / videoHeight * height) - width) / 2;
      videoWidthAdjust = (videoWidth / videoHeight * height) / width * 100;
    } else {
      videoVerticalOffset = - ((videoHeight / videoWidth * width) - height);
      videoWidthAdjust = 100;
    }
  };

  calculateVideoOffset();

  // Look for resize event
  window.addEventListener('resize', () => {
    height = window.innerHeight;
    width = window.innerWidth;
    calculateVideoOffset();
  });

  const scrollDown = () => {
    jquery([document.documentElement, document.body]).animate({
        scrollTop: jquery("#page1").offset().top
    }, 1000);
  };

  onMount(() => {
    textBalancer('.title, .byline');
  });

</script>

<style>
  h1 {
    font-size: 60px;
    line-height: 1.2em;
    padding:  20px 30px;
    background-color: #33333388;
    white-space: pre-wrap;
    margin: auto;
  }

  .byline {
    padding: 10px 20px;
    background-color: #33333388;
    margin: 10px auto 0;
    display: inline-block;
    line-height: 1.2em;
  }

  .credit {
    font-size: 10px;
    margin-top: 10px;
  }

  .logo {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 250px;
  }

  .page {
    height: 100%;
    background-color: #333;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 50px;
    position: relative;
    overflow: hidden;
    /* scroll-snap-align: start; */
  }

  .title-box {
    text-align: center;
    z-index: 100;
  }

  .bg-video {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
  }

  .arrow {
    border: solid white;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 15px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    margin: 15px 0 0 15px;
  }

  @media screen and (max-width: 600px) {
    h1 {
      font-size: 40px;
      padding: 20px;
    }

    .page {
      padding: 30px 20px;
    }
  }
</style>

<div class="page">
  <video autoplay muted playsinline webkit-playsinline loop class="bg-video"
  data-timecoded data-hasplayedthrough="false" poster=""
  src="intro.mp4" style="display: initial; left: {videoHorizontalOffset}px; right: {videoHorizontalOffset}px; top: {videoVerticalOffset}px; width: {videoWidthAdjust}%;">
    <source type="video/mp4" src="intro.mp4">
  </video>
  <a href="https://www.thenewslens.com/">
    <img class="logo" src="logo.png" alt="TNL Logo">
  </a>
  <div class="title-box">
    <h1 class="title">{data.title}</h1>
    <div class="byline">{data.byline}</div>
    <div class="credit">{data.video_credit}</div>
    <i class="arrow" on:click={scrollDown} />
  </div>
</div>
